var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 3.66667C10.5986 3.66667 10.8529 3.77202 11.0404 3.95956C11.228 4.1471 11.3333 4.40145 11.3333 4.66667V14C11.3333 14.2652 11.228 14.5196 11.0404 14.7071C10.8529 14.8946 10.5986 15 10.3333 15H3C2.86868 15 2.73864 14.9741 2.61732 14.9239C2.49599 14.8736 2.38575 14.8 2.29289 14.7071C2.20003 14.6142 2.12638 14.504 2.07612 14.3827C2.02587 14.2614 2 14.1313 2 14V4.66667C2 4.40145 2.10536 4.1471 2.29289 3.95956C2.48043 3.77202 2.73478 3.66667 3 3.66667H10.3333ZM12.9973 1C13.246 0.999846 13.4859 1.09237 13.67 1.25952C13.8542 1.42667 13.9695 1.65645 13.9933 1.904L13.9973 2V10.9953C13.9971 11.1653 13.9321 11.3287 13.8154 11.4522C13.6988 11.5758 13.5394 11.6502 13.3697 11.6601C13.2001 11.6701 13.0331 11.6149 12.9028 11.5058C12.7725 11.3968 12.6887 11.2421 12.6687 11.0733L12.664 10.9953V2.33333H6C5.83671 2.33331 5.67911 2.27336 5.55709 2.16486C5.43506 2.05635 5.35711 1.90683 5.338 1.74467L5.33333 1.66667C5.33336 1.50338 5.3933 1.34578 5.50181 1.22375C5.61032 1.10173 5.75983 1.02377 5.922 1.00467L6 1H12.9973Z",
    fill: "#5F6975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.982706366c901e1b4403800bf680c45a.svg";
export { ForwardRef as ReactComponent };